import { v4 as uuidv4 } from "uuid";
import { HttpRequest } from "../utils";

const httpRequest = new HttpRequest();

// Create and both decisions are wrapped in withIdempotency on the backend, so
// each call carries a fresh key - same as every return mutation.
const idem = (): Record<string, string> => ({ "Idempotency-Key": uuidv4() });

export type DeliveryDateChangeStatus = "PENDING" | "APPROVED" | "REJECTED";

export interface IDeliveryDateChangeRequest {
  id: string;
  businessId: string;
  orderId: string;
  requestedByUserId: string;
  requestedBySide: "BUYER" | "SUPPLIER";
  /** Snapshotted when the request was made, not read back off the order. */
  currentDeliveryDate: string | null;
  requestedDeliveryDate: string;
  reason: string | null;
  status: DeliveryDateChangeStatus;
  decidedByUserId: string | null;
  decidedAt: string | null;
  decisionNote: string | null;
  createdAt: string;
}

export const list = async (orderId: string): Promise<IDeliveryDateChangeRequest[]> =>
  httpRequest.get(`/ord/order/${orderId}/delivery-date-change`);

export const create = async (
  orderId: string,
  body: { requestedDeliveryDate: string; reason?: string | null },
): Promise<IDeliveryDateChangeRequest> =>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  httpRequest.post(`/ord/order/${orderId}/delivery-date-change`, body as any, idem());

export const approve = async (
  id: string,
  body?: { decisionNote?: string | null },
): Promise<IDeliveryDateChangeRequest> =>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  httpRequest.post(`/ord/delivery-date-change/${id}/approve`, (body ?? {}) as any, idem());

// The note is required by the endpoint, not optional as it is on approve.
export const reject = async (
  id: string,
  body: { decisionNote: string },
): Promise<IDeliveryDateChangeRequest> =>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  httpRequest.post(`/ord/delivery-date-change/${id}/reject`, body as any, idem());
